import React, { useEffect, useState } from 'react';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import Blocks from './blocks';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getAwardsList } from '../../../services/api';
import { QQShare } from 'ThreeTerminal_mobile_dynamic';
import { CallupHeader, Intro, Alerter, Alter, GotoTop } from '../../vote/layout/index';
import Footer from '@ifeng-fe/container_channel/common/client/components/footer/';
import { ChipMap } from '@src/services/chip';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';

/* eslint-disable */
const PC = allData.pc;
/* eslint-disable */

const styles = require(PC ? '../../../pc/index/layout/index.css' : './index.css').default;

const MENUS = {
    获奖案例: {
        blocks: ['PrizeList', 'Prize', 'Prize2'],
    },
    盛典现场: {
        blocks: ['Flow', 'Live', 'News', 'Pics', 'Stars'],
    },
    巅峰对话: {
        blocks: ['Talk', 'Talk2'],
    },
};

const BlockLayout = errorBoundary(({ content, menu }) => {
    const blocks = MENUS[menu].blocks;

    const common = [
        <Chip key={'Alerter'} {...ChipMap.Alerter} content={content['Alerter']}>
            <div />
        </Chip>,
    ];

    if (!blocks) return common;

    console.log('blocks', blocks);

    const BlocksComp = blocks.map((item, index) => {
        const Block = Blocks[item];

        return (
            <Chip {...ChipMap[item]} key={item} content={content[item]}>
                <Block />
            </Chip>
        );
    });

    return BlocksComp.concat(common);
});

const qqShareCofig = {
    title: '2021第六届博鳌旅游传播论坛',
    img: 'https://x0.ifengimg.com/ucms/2021_49/C7B0473A184257F5142EA763301B1A43B41938AC_size1131_w1200_h1200.jpg',
    desc: '',
    cb: () => {
        console.log('分享成功');
    },
};

const Layout = errorBoundary(({ content }) => {
    return (
        <div className={styles.layout}>
            {!PC && <CallupHeader />}
            <QQShare content={qqShareCofig} />
            <Alerter.Provider>
                <Intro />
                <Content content={content} />
                <Alter />
                <GotoTop />
                {PC && (
                    <div className={styles.footer}>
                        <Footer content={content.footer} />
                    </div>
                )}
            </Alerter.Provider>
        </div>
    );
});

export default errorBoundary(Layout);

const SmallAlert = type =>
    errorBoundary(({ toggle }) => {
        const content = {
            Vote: () => (
                <div className={styles.vote}>
                    <div className={styles.title}>点击进入投票界面</div>
                    <div className={styles.btn} onClick={() => (location.href = 'https://ishare.ifeng.com/TCAwards')}>
                        <LazyImg src={require('../assets/vote.png')} alt="" />
                    </div>
                </div>
            ),
            Lock: () => (
                <div className={styles.lock}>
                    <div className={styles.title}>
                        <span>将于11月21日开启</span>
                    </div>
                    <div className={styles.text}>敬请期待</div>
                </div>
            ),
            Staging: () => (
                <div className={styles.staging}>
                    <div className={styles.title}>
                        <span>投票数据统计中</span>
                    </div>
                    <div className={styles.subtitle}>11月21日公布最终获奖名单</div>
                    <div className={styles.text}>敬请期待</div>
                </div>
            ),
        };

        return (
            <div className={styles.SmallAlert}>
                {content[type]()}
                <LazyImg
                    className={styles.close}
                    src={require('../assets/close.png')}
                    alt=""
                    onClick={() => toggle()}
                />
            </div>
        );
    });

const lockType = (menu, config) => {
    if (config?.index === '1' && menu === '品牌指数') {
        return 'Lock';
    }
    // if (config?.vote === '1' && menu === '获奖案例') {
    //     return 'Vote';
    // }
    // if (config?.vote === '2' && menu === '获奖案例') {
    //     return 'Staging';
    // }

    return null;
};

const checkAlert = (menu, config, toggle) => {
    const type = lockType(menu, config);

    if (type) toggle({ Component: SmallAlert(type) });
};

const Content = errorBoundary(({ content }) => {
    const [data, toggle] = Alerter.useContainer();
    const [menu, setMenu] = useState('盛典现场');
    const [subMenu, setSubmenu] = useState(0);
    const lock = lockType(menu, content.Alerter);

    console.log('content', content);

    const MenuSet = type => {
        checkAlert(type, content.Alerter, toggle);
        setMenu(type);
    };

    useEffect(
        () => {
            setSubmenu(1);
        },
        [menu],
    );

    useEffect(() => {
        checkAlert(menu, content.Alerter, toggle);
    }, []);

    return (
        <div className={styles.content}>
            <Menu content={content} menu={menu} setMenu={MenuSet} subMenu={subMenu} setSubmenu={setSubmenu} />
            {MENUS[menu] &&
                !lock &&
                MENUS[menu].id && <TableList id={MENUS[menu].id} cardType={MENUS[menu].content} subMenu={subMenu} />}
            <BlockLayout content={content} menu={menu} />
            <ChipEdit transform={transform} />
        </div>
    );
});

const TableList = errorBoundary(({ id, subMenu, cardType }) => {
    const [list, setList] = useState(null);

    const getList = async () => {
        const { data } = await getAwardsList(id);

        setList({ type: cardType, data });
    };

    useEffect(
        () => {
            getList();
        },
        [cardType],
    );

    const IndexCards = errorBoundary(({ data }) => {
        const _data = data.slice().filter(some => !!some.length);
        const last = _data.pop();

        return (
            <div className={styles.indexCard}>
                <div className={styles.table}>
                    <div className={styles.title}>
                        <div>排名</div>
                        <div>名称</div>
                        <div>数值</div>
                    </div>
                    <div className={styles.content}>
                        {_data.slice(1).map((item, index) => {
                            return (
                                <div key={index} className={styles.items}>
                                    <div>
                                        {index < 3 ? (
                                            <LazyImg src={require(`../assets/rank${index}.png`)} alt="" />
                                        ) : (
                                            index + 1
                                        )}
                                    </div>
                                    <div>{item[0]}</div>
                                    <div>{item[1]}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={styles.note}>{last[0]}</div>
            </div>
        );
    });

    const AwardCards = errorBoundary(({ data }) => {
        return (
            <div className={styles.awardCard}>
                {data.filter(some => !!some.length).map((item, index) => {
                    return (
                        <div key={index} className={styles.item}>
                            <div className={styles.title}>{item[1] && <LazyImg src={item[1]} alt="" />}</div>
                            {item.slice(2).map(text => {
                                return (
                                    <div className={styles.text} key={text}>
                                        {text}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    });

    if (!list || list.type !== cardType) return null;

    if (cardType === 'index') return <IndexCards data={list.data[subMenu].data} />;
    if (cardType === 'award') return <AwardCards data={list.data[subMenu].data} />;
});

const Menu = errorBoundary(({ menu, setMenu, subMenu, setSubmenu, content }) => {
    return (
        <div className={styles.menu}>
            <div className={`${Object.keys(MENUS).length === 3 ? `${styles.index}` : `${styles.centerMenu}`}`}>
                {Object.keys(MENUS).map((item, index) => {
                    return (
                        <div onClick={() => setMenu(item)} key={index}>
                            <LazyImg
                                src={require(`../assets/menu_${index}${item === menu ? '_active' : ''}${
                                    PC ? '_pc' : ''
                                }.png`)}
                                alt=""
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
});
